
      import Saler from './saler.vue'
      import type { App, Plugin } from 'vue'

      export const SalerPlugin: Plugin = {
        install(app: App) {
          app.component('Saler', Saler)
        },
      }
      export { Saler }
      